// extracted by mini-css-extract-plugin
export default {"root":"ProfileIconCard_root__MxjEr"};